import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { GenericResourcesContainerModel } from '../../../../../models/aggregates/generic-resources';


@Injectable({ 
  providedIn: 'root' 
})
export class AppGenericService extends BaseApiTemplateService<GenericResourcesContainerModel>{

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'app-generic-resources';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'app-generic-resources';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'app-generic-resources';
    this.httpClient = http;
  }
}